module.exports = __webpack_public_path__ + "img/errorImage1.43ea4307.png";